import ComponentName from '@/constant/componentName'

export default [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/opportunity',
    children: [
      {
        component: () => import('../../views/opportunity-manage/index.vue'),
        path: 'list',
        name: ComponentName.opportunity.index,
        auth: '*',
        meta: {
          title: '商机管理'
        },
        props: {
          componentName: ComponentName.opportunity.index
        },
        children: [
          {
            component: () => import('../../views/opportunity-manage/detail/Detail.vue'),
            path: 'detail',
            name: ComponentName.opportunity.detail,
            props: true,
            auth: '*',
            meta: {
              title: '商机详情'
            }
          }
        ]
      }
    ]
  }
]
